import { Component, OnDestroy, OnInit } from '@angular/core';
import { PartnerService } from '../../../services/partner.service';
import { MatDialog } from '@angular/material/dialog';
import { AddPartnerModalComponent } from '../../_modals/add-partner-modal/add-partner-modal.component';
import { AddPartnerGroupModalComponent } from '../../_modals/add-partner-group-modal/add-partner-group-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { openFilePicker } from '../../../functions';

@Component({
  selector: 'app-partner-select-header',
  templateUrl: './partner-select-header.component.html',
  styleUrls: ['./partner-select-header.component.scss']
})
export class PartnerSelectHeaderComponent implements OnInit, OnDestroy {

  // showPartnersMgmt = true;
  // showPartnerGroupsMgmt = false;

  routeUrl: string;

  isImportingGroups = false; 

  subs: Subscription[] = [];

  constructor(private partnerService: PartnerService, public dialog: MatDialog, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {

    // this.showAllPartners();

    // this.partnerService.showPartnersMgmt$.subscribe((x) => {
    //   this.showPartnersMgmt = x;
    // });

    // this.partnerService.showPartnerGroupsMgmt$.subscribe((x) => {
    //   this.showPartnerGroupsMgmt = x;
    // });

    //check route to determine what button to display
    // this.route.url.subscribe(urlSegments => {
    //   this.routeUrl = urlSegments.join('/');
    // });

    this.subs.push(this.partnerService.startImport$.subscribe(() => {
      this.isImportingGroups = true;
    }));

    this.subs.push(this.partnerService.doneImporting$.subscribe(res => {
      this.isImportingGroups = false;
    }, ex => {
      this.isImportingGroups = false;
    }));
}

ngOnDestroy() {
    this.subs.forEach(x => x.unsubscribe);
}

  showAllPartners() {
    // this.partnerService.setShowPartnersMgmt(true);
    // this.partnerService.setShowPartnerGroupsMgmt(false);
    this.router.navigate(['data/partners/lists/partners-list']);
  }

  showPartnerGroups() {
    // this.partnerService.setShowPartnerGroupsMgmt(true);
    // this.partnerService.setShowPartnersMgmt(false);
    this.router.navigate(['data/partners/lists/partner-groups-list']);
  }

  addNewPartner(): void {
    const dialogRef = this.dialog.open(AddPartnerModalComponent, {
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

      this.partnerService.getPartners().subscribe((x) => {
        this.partnerService.setPartners(x);
      });

    });
  }

  addNewPartnerGroup() {
    const dialogRef = this.dialog.open(AddPartnerGroupModalComponent, {
      // width: '800px',
      // height: '400px',
      // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');

      this.partnerService.getPartnerGroups().subscribe((x) => {
        this.partnerService.setPartnerGroups(x);
      });

    });
  }


  isBtnSelected(btn: string): boolean{

    const partnerListStr = 'partners-list';
    const groupListStr = 'partner-groups-list';

    if(btn == 'partners' && this.router.url.match(partnerListStr)){
      return true;
    }
    else if (btn == 'groups' && this.router.url.match(groupListStr)){
      return true;
    }
    else{
      return false;
    }
    
  }

  async importPartnerGroups() {
    
    openFilePicker('.xls,.xlsx').subscribe(file => {
      this.partnerService.importPartnerGroups(file);
    });
  }

}
